import API from '../AxiosInstance';

export default {
  getPodLegal: function(podID) {
    return API.get('pods/'+podID+'/legal');
  },

  savePodLegal: function(podID, payload) {
    return API.post('pods/'+ podID+'/legal', payload);
  },
}
